export enum AuditStreamType {
    Splunk = "Splunk",
    SumoLogic = "Sumo Logic",
}
